import { parseApiError } from './apiError';
const base = () => `${process.env.REACT_APP_API_URL}api/reviews`;

const authHeaders = (token: string) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

export const getAllReviews = async (token: string) => {
  const res = await fetch(base(), { headers: authHeaders(token) });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
};

export const deleteReview = async (id: string, token: string) => {
  const res = await fetch(`${base()}/${id}`, {
    method: 'DELETE',
    headers: authHeaders(token)
  });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
};
